import React, { useState } from 'react';
import './SignUp.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";

const EmailVerification = () => {
    return (
        <div className="background-image overflow-hidden">
            <style>
                {`
                    .background-image {
                        background-image: url('../assetsTemplates/template1/img/carousel-4.jpg');
                        background-size: cover;
                        background-position: center;
                    }
                    .input-wrapper {
                        position: relative;
                    }
                    .toggle {
                        position: absolute;
                        top: 70%;
                        right: 10px;
                        transform: translateY(-50%);
                        cursor: pointer;
                    }
                `}
            </style>

            <div className="wrapper mt-5 pt-5">
                <div className="container px-4 py-5 px-md-5 text-center text-lg-start my-5">
                    <div className="row gx-lg-5 align-items-center mb-5">
                        <div className="col-lg-6 mb-5 mb-lg-0" style={{ zIndex: 10 }}>
                        </div>
                        <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
                            <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
                            <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>

                            <div className="card bg-glass">
                                <div className="card-body px-4 py-5 px-md-5">
                                    <div className="text-center my-4">
                                        <h3 className="font-weight-bold mb-3">Congratulations !</h3>
                                        <h3 className="text-muted font-italic fs-5">Form Submitted successfully. Check your inbox to confirm your email</h3>
                                    </div>
                                    <form>
                                        <div className="form-outline mb-4">
                                            <div className="col-md-8 offset-md-2">
                                                <img className="img-fluid" src="../assetsTemplates/template1/img/mailVerif.jpg" alt="send_mail" />
                                            </div>
                                        </div>
                                    </form>
                                    <div className="text-center mt-3">
                                        <p>
                                            <NavLink to="/SignUp">Turn back</NavLink>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;
